/**
 * Titulares y acentos que usan `primary.main` en claro. En modo oscuro la paleta
 * legalmente pone fondos verdes oscuros y el mismo verde como `primary.main`,
 * con poco contraste — devolvemos blanco para texto sobre la página.
 */
export function legalmenteForegroundOnPage(theme) {
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main;
}
